import React from "react";
import HashLoader from "react-spinners/HashLoader";

const Loader = () =>{
    return (
        <div className="sweet-loading main-loader">
          <HashLoader
            size={100}
            color={"#212529"}
            loading={true}
          />
        </div>
      );
}

export default Loader;